<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" :title="title">
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            right
            top
          >
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <form autocomplete="off" @submit.prevent="save()">
          <v-row>
            <v-col class="mt-2" cols="12" sm="6">
              <label class="font-weight-medium body-2">
                Theme Name
                <span class="required error--text">*</span>
              </label>
              <v-text-field
                counter="100"
                required
                v-model.trim="themeName"
                placeholder="Theme"
                disabled
              ></v-text-field>
            </v-col>
            <v-col class="mt-2" cols="12" sm="6">
              <label class="font-weight-medium body-2">
                Skill
                <span class="requir error--text">*</span>
              </label>
              <v-autocomplete
                placeholder="Enter Skill Name"
                class="my-0 py-1"
                v-model="skills"
                item-value="name"
                :items="themeWiseSkills"
                key="id"
                item-text="name"
                multiple
                chips
              >
              </v-autocomplete>
            </v-col>
            <v-col class="mt-2" cols="12" sm="6">
              <v-textarea
                counter
                label="Goal"
                required
                rows="2"
                v-model.trim="goal"
              >
                <span class="requir error--text">*</span>
              </v-textarea>
            </v-col>
            <v-col class="mt-2" cols="12" sm="6">
              <v-textarea
                counter
                label="Developmental Area"
                required
                rows="2"
                v-model.trim="developmentArea"
              >
                <span class="requir error--text">*</span>
              </v-textarea>
            </v-col>
            <v-col class="mt-2" cols="12" sm="6">
              <v-textarea
                counter
                label="Outcome"
                required
                rows="3"
                v-model.trim="outcome"
              >
                <span class="requir error--text">*</span>
              </v-textarea>
            </v-col>
            <v-col class="mt-2" cols="12" sm="6">
              <v-textarea
                counter
                label="Resource from WOW Kit Area"
                required
                rows="3"
                v-model.trim="resourcesFromWowKit"
              >
                <span class="requir error--text">*</span>
              </v-textarea>
            </v-col>
            <v-col class="mt-2" cols="12" sm="6">
              <v-textarea
                counter
                label="Others"
                required
                rows="3"
                v-model.trim="others"
              >
                <span class="requir error--text">*</span>
              </v-textarea>
            </v-col>
            <v-col class="mt-2" cols="12" sm="6">
              <v-textarea
                counter
                label="Preparation"
                rows="3"
                required
                v-model.trim="preparation"
              >
                <span class="requir error--text">*</span>
              </v-textarea>
            </v-col>

            <v-col cols="12" md="12">
              <label class="font-weight-medium body-2"> Procedure </label>
              <div v-for="(n, i) of procedure" :key="i">
                <v-card-component>
                  <v-row>
                    <v-col cols="12" md="12" class="pt-0 pb-0">
                      <v-row>
                        <v-col cols="12" sm="2">
                          <v-text-field
                            class="my-0 py-4"
                            counter="100"
                            placeholder="Procedure Title"
                            :required="i === 0"
                            v-model.trim="procedure[i].step"
                            maxlength="100"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                          <v-text-field
                            type="number"
                            min="1"
                            class="my-0 py-4"
                            counter="100"
                            placeholder="Procedure Time in Mins"
                            :required="i === 0"
                            v-model.trim="procedure[i].time"
                            maxlength="100"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="4"
                          class="d-flex pt-0 pb-5 flex-column justify-center align-center"
                        >
                          <v-file-input
                            small-chips
                            v-model="procedure[i].files"
                            placeholder="Click to Upload"
                            :messages="['(max file size allowed 100MB)']"
                            accept=".pdf,.png,.jpeg,.jpg"
                          ></v-file-input>
                          <span class="has-text-danger"
                            >Allowed files: '.pdf, .png, jpg, jpeg.</span
                          >
                          <div></div>
                        </v-col>
                        <v-col cols="12" sm="2">
                          <v-checkbox
                            label="Allow File Download"
                            v-model="procedure[i].isDownloadableValue"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-col>
                    <!--Sub step starts-->
                    <v-col cols="12" md="10">
                      <label class="font-weight-medium body-2">
                        <b> Add Procedure Steps </b>
                      </label>
                      <ckeditor
                        required
                        v-model="procedure[i].steps[0].steps"
                        ref="ckeditorRef"
                        :toolbar="toolbar"
                      ></ckeditor>
                    </v-col>
                    <!--ends-->
                    <v-col
                      cols="12"
                      md="2"
                      class="d-flex pt-0 pb-0 flex-column justify-center align-center"
                    >
                      <label class="font-weight-medium body-2"
                        >No. {{ procedure[i].position }}</label
                      >
                      <v-card-actions>
                        <v-btn
                          title="Delete procedure"
                          elevation="1"
                          color="error"
                          @click="deleteProcedureRow(i, procedure[i])"
                        >
                          <v-icon left> mdi-trash-can </v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-card-component>
              </div>
              <v-card-actions class="d-flex justify-end">
                <v-btn
                  bottom
                  right
                  elevation="1"
                  color="primary"
                  @click="
                    procedure.push({
                      step: '',
                      time: '',
                      position: procedure.length + 1,
                      steps: [{ steps: '', position: 1 }],
                      files: {}
                    })
                  "
                >
                  <v-icon left> mdi-plus </v-icon>
                  Add Procedure
                </v-btn>
              </v-card-actions>
            </v-col>

            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-btn bottom right elevation="1" color="primary" type="submit">
                  <v-icon left> mdi-content-save </v-icon>
                  Save all
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
// import _ from 'lodash'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'

import CKEditor from 'ckeditor4-vue'
import moment from 'moment'
import Vue from 'vue'
Vue.use(CKEditor)

export default {
  components: { VCardComponent, MaterialCard },
  props: ['dayId'],
  data () {
    return {
      week: [],
      day: [],
      dayList: [],
      dayDetails: [],
      skills: [],
      goal: '',
      developmentArea: '',
      outcome: '',
      name: '',
      procedurePosition: 0,
      resourcesFromWowKit: '',
      toolbar: [
        'bold',
        'italic',
        '|',
        'undo',
        'redo',
        '|',
        'numberedList',
        'bulletedList'
      ],
      others: '',
      preparation: '',
      procedures: [],
      themeName: '',
      classList: [],
      procedure: [
        {
          step: '',
          time: '',
          position: 1,
          steps: [{ steps: '', position: 1 }],
          files: null
        }
      ],
      isDownloadableValue: false,
      procedureFiles: [],
      steps: [
        {
          position: '',
          steps: ''
        }
      ],
      themeList: [],
      themeWiseSkills: [],
      title: 'Week at a glance',
      allowedFiles: ['pdf', 'jpg', 'png', 'jpeg'],
      skillsStr: ''
    }
  },
  created: async function () {
    await this.getIndividualDayById()
    await this.getThemeList()
    await this.fetchSkills()
  },
  watch: {},
  methods: {
    save: async function () {
      try {
        for (let item of this.procedure) {
          if (item.step === '' || item.time === '') {
            return this.errMsg('This field is required!')
          }
        }
        let skillArray = []
        for (let skillName of this.skills) {
          let selectedSkill = null
          if (this.dayList.Skills.length) {
            selectedSkill = this.dayList.Skills.find(
              (obj) => obj.skills === skillName
            )
          }
          if (!selectedSkill) {
            selectedSkill = this.themeWiseSkills.find(
              (obj) => obj.name === skillName || obj.skills === skillName
            )
            if (selectedSkill) {
              selectedSkill.skills = selectedSkill.name
              delete selectedSkill.id
            }
          }
          if (selectedSkill) {
            skillArray.push(selectedSkill)
          }
        }
        let deletedSkills = []
        if (this.dayList.Skills.length) {
          for (let deletedData of this.dayList.Skills) {
            if (
              !skillArray.find(
                (innerObj) => innerObj.skills === deletedData.skills
              )
            ) {
              deletedSkills.push(deletedData)
            }
          }
          if (deletedSkills.length) {
            for (let skill of deletedSkills) {
              skill.deletedAt = moment()
            }
            skillArray.push(...deletedSkills)
          }
        }
        this.procedureFiles = [...this.procedure]
        let formData = {
          goal: this.goal,
          developmentArea: this.developmentArea,
          outcome: this.outcome,
          resourcesFromWowKit: this.resourcesFromWowKit,
          others: this.others,
          preparation: this.preparation,
          skills: skillArray,
          procedure: this.procedure
        }
        let response = null
        if (this.isEdit) {
          response = await http.put(
            `${CONSTANTS.API_URL}/api/curriculum_cms/update-dayatglance/${this.dayId}`,
            formData
          )
        } else {
          formData.dayAtGlanceID = this.dayId
          response = await http.post(
            `${CONSTANTS.API_URL}/api/curriculum_cms/create-dayschedule`,
            formData
          )
        }
        if (response.data.length > 0) {
          for (let obj of this.procedureFiles) {
            if (obj.files) {
              let procedureID = obj.id
              if (!obj.id) {
                let procedure = response.data.find(
                  (resp) =>
                    resp.step === obj.step && resp.position === obj.position
                )
                procedureID = procedure.id || null
              }
              if (!procedureID) {
                throw new Error('Unable to upload files ')
              }
              let formData = new FormData()
              formData.append('files', obj.files)
              formData.append('procedureID', procedureID)
              formData.append('isDownloadable', obj.isDownloadableValue)
              const res = await http.post(
                `${CONSTANTS.API_URL}/api/curriculum_cms/add-document`,
                formData
              )
              console.log(res)
            }
          }
          await this.getIndividualDayById()
        }
        this.okMsg(response.data.message)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getIndividualDayById: async function () {
      try {
        let res = await http.get(
          `${CONSTANTS.API_URL}/api/curriculum_cms/get-dayatglance/${this.dayId}`
        )
        this.dayList = res.data.dayDetailsByID
        if (this.dayList) {
          this.title = `${this.dayList.title} (${this.dayList.themeTime} Minutes)`
          this.themeName = this.dayList.theme
          this.themeTime = this.dayList.themeTime
          if (this.dayList.dayDetails.length) {
            this.isEdit = true
            let dayDetails = this.dayList.dayDetails[0]
            this.goal = dayDetails.goal
            this.outcome = dayDetails.outcome
            this.preparation = dayDetails.preparation
            this.others = dayDetails.others
            this.resourcesFromWowKit = dayDetails.resourcesFromWowKit
            this.developmentArea = dayDetails.developmentArea
            if (this.dayList.Procedure.length) {
              this.procedure = []
              let positionArray = this.dayList.Procedure.map(
                (obj) => obj.position
              )
              positionArray = positionArray.map((obj) => Number(obj))
              let maxPosition = Math.max(...positionArray)
              let positionDifference = 0
              if (maxPosition !== this.dayList.Procedure.length) {
                positionDifference =
                  Number(maxPosition) - Number(this.dayList.Procedure.length)
              }
              for (let proc of this.dayList.Procedure) {
                this.procedure.push({
                  id: proc.id,
                  step: proc.step,
                  time: proc.time,
                  position: Number(proc.position) - Number(positionDifference),
                  files: null,
                  isDownloadableValue: false,
                  steps: proc.ProcedureSteps.length
                    ? proc.ProcedureSteps.map((obj) => {
                      return {
                        id: obj.id,
                        steps: obj.steps,
                        position: obj.position
                      }
                    })
                    : []
                })
              }
            }
            this.skills = this.dayList.Skills.map((obj) => {
              return {
                id: obj.id,
                skills: obj.skills,
                name: obj.skills,
                deletedAt: obj.deletedAt,
                isHighlighted: obj.isHighlighted
              }
            })
          }
        }
        this.day = res.data.day
        this.week = res.data.week
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    uploadFile: async function () {
      try {
        let formData = {
          isDownloadable: this.isDownloadableValue,
          files: this.file
        }
        let res = await http.get(
          `${CONSTANTS.API_URL}/api/curriculum_cms/add-document`,
          formData
        )
        res = res.data
        console.log('res : ', res)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getThemeList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(
          `${CONSTANTS.API_URL}/api/curriculum_cms/getall-themes`,
          {
            params: {
              page: 0,
              size: 1000
            }
          }
        )
        this.themeList = res.data.rows
        this.totalPages = res.data.totalPages
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    fetchSkills: async function () {
      let themeObj = this.themeList.find((obj) => obj.name === this.themeName)
      if (themeObj) {
        this.themeWiseSkills = themeObj.Skills
      } else {
        this.themeWiseSkills = []
      }
    },

    deleteProcedureRow: async function (e, item) {
      try {
        if (item.id) {
          await http.delete(
            `${CONSTANTS.API_URL}/api/curriculum_cms/day-at-glance/delete/procedure/${item.id}`
          )
        }
        this.procedure = this.procedure.filter(
          (obj) => obj.step !== item.step && obj.time !== item.time
        )
        await this.getIndividualDayById()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    deleteDropFile (files, i) {
      files.splice(i, 1)
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
